import * as React from 'react';
import { connect } from 'react-redux';

import CreateNewProfilesEntitiesListHeaderRow from './components/create-new-profiles-entities-list-header-row/CreateNewProfilesEntitiesListHeaderRow';
import CreateNewProfilesEntitiesListRow from './components/create-new-profiles-entities-list-row/CreateNewProfilesEntitiesListRow';
import CreateNewProfilesEntitiesListAddNew from './components/create-new-profiles-entities-list-add-new/CreateNewProfilesEntitiesListAddNew';
import CreateNewProfilesEntitiesListPagination from './components/create-new-profiles-entities-list-pagination/CreateNewProfilesEntitiesListPagination';
import CreateNewProfilesEntitiesListErrors from './components/create-new-profiles-entities-list-errors/CreateNewProfilesEntitiesListErrors';

import {
  CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER
} from 'modules/create-new-profiles/constants/common';

import { getPageEntities } from 'modules/create-new-profiles/utils/pagination';

import { CreateNewProfilesEntity } from 'modules/create-new-profiles/types/CreateNewProfiles.type';
import { State } from 'types';

interface StateProps {
  entities: Array<CreateNewProfilesEntity>,
  page: number
}

type Props = StateProps;

const CreateNewProfilesEntitiesList = ({ entities, page }: Props): JSX.Element => (
  <div key={`${page}-${entities.length}`}>
    <CreateNewProfilesEntitiesListHeaderRow />
    {entities.map((entity, index) => (
      <CreateNewProfilesEntitiesListRow
        key={index}
        entity={entity}
        index={index}
        isDeletable={entities.length > 1}
      />
    ))}
    <CreateNewProfilesEntitiesListErrors />
    <CreateNewProfilesEntitiesListAddNew />
    <CreateNewProfilesEntitiesListPagination />
  </div>
);

const mapStateToProps = ({ createNewProfiles }: State): StateProps => {
  const { createEntitiesModal } = createNewProfiles;

  if (createEntitiesModal.type === CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER) {
    return {
      entities: getPageEntities(createEntitiesModal.page, createEntitiesModal.entities),
      page: createEntitiesModal.page
    };
  }

  if (createEntitiesModal.data?.type === 'successful-upload') {
    return {
      entities: getPageEntities(createEntitiesModal.data.page, createEntitiesModal.data.entities),
      page: createEntitiesModal.data.page
    };
  }

  throw new Error(`Impossible state to show CreateNewProfilesEntitiesList component; state: ${JSON.stringify(createEntitiesModal)}`);
};

export default connect(mapStateToProps)(CreateNewProfilesEntitiesList);
